import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { inflect } from 'lib/translate'
import { graphqlPrevLocationCached } from 'lib/utils/store/navHistory'
import useVerticalBackUrl from './useVerticalBackUrl'
import { getReferrerVertical } from 'lib/verticalReferrer'
import { urlWithLangParam } from 'lib/helpers'

import Link from 'components/Link'

const VerticalBackLink = ({ prevLocation, children, className }) => {
    const { t, i18n } = useTranslation(['vehicles'])
    const verticalBack = useVerticalBackUrl()

    // Display vertical for testing purposes:
    // const verticalBack = { vertical: 'car', backUrl: 'https://www.nettiauto.com/en/mercedes-benz/a/12008547' }

    const renderLink = () => {
        const backText = t('common:navigation.backToVertical', {
            vertical: inflect(t, t(`vehicles:vertical.${verticalBack.name}.name`), 'illative')
        })

        return (
            <Link
                className={classNames('vertical-back-navigation', className)}
                to={urlWithLangParam(verticalBack.url, i18n.language)}
                target="_self"
                alt={backText}
                trackName="backToVertical"
                trackLabel="vertical"
                onClick={(e) => {
                    const referrerVertical = getReferrerVertical(document.referrer)

                    // act as browser back button in case we just arrived to omanettix (from vertical)
                    if (referrerVertical && !prevLocation && window.history.length > 1) {
                        e.preventDefault()
                        window.history.back()
                    }
                }}
            >
                {children({ ...verticalBack })}
            </Link>
        )
    }

    return !!verticalBack && renderLink()
}

VerticalBackLink.propTypes = {
    children: PropTypes.func.isRequired,
    className: PropTypes.string,
}

export default flowRight(
    graphqlPrevLocationCached,
)(VerticalBackLink)
